export {
  Separator,
  type SeparatorProps,
  type SeparatorVariant,
  type SeparatorSpacing,
} from './separator';
export { default } from './separator';
